'use strict';

(function() {
    angular
      .module('specsguardApp')
      .directive('sgMatrixElementValue', sgMatrixElementValue);

    function sgMatrixElementValue() {
      return {
        restrict: 'EA',
        templateUrl: 'app-legacy/project/areas/matrix/matrix-element-value/matrix-element-value.tmpl.html',
        controller: 'matrixElementValue',
        controllerAs: '$matrixElementValue',
        replace: true,
        scope: {
          item: '=',
          customValues: '=',
          model: '=',
          selectedElements: '='
        }
      };
    }
})();
